import React, { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'ae-traffic-project-v1';

const initialPhases = [
  {
    id: 'phase-1',
    name: 'Phase 1: Baseline Measurement',
    timeline: 'First week of February',
    color: '#6366f1',
    collapsed: false,
    tasks: [
      { id: 't1', text: 'Pull total visits & unique visitors for /projects pages from Google Analytics', status: 'todo', priority: 'high', notes: '' },
      { id: 't2', text: 'Export traffic source breakdown (organic, direct, referral, social, paid) from GA', status: 'todo', priority: 'high', notes: '' },
      { id: 't3', text: 'Pull search query data for /projects pages from Google Search Console', status: 'todo', priority: 'high', notes: '' },
      { id: 't4', text: 'Extract bot vs human traffic segmentation from Cloudflare analytics', status: 'todo', priority: 'high', notes: '' },
      { id: 't5', text: 'Identify LLM crawler traffic (GPTBot, ClaudeBot, etc.) from Cloudflare/server logs', status: 'todo', priority: 'high', notes: '' },
      { id: 't6', text: 'Consolidate baseline report: total visits, uniques, sources, human/bot/LLM split', status: 'todo', priority: 'high', notes: '' },
      { id: 't7', text: 'Define X% traffic growth target based on baseline numbers', status: 'todo', priority: 'high', notes: '' },
      { id: 't8', text: 'Set up GA MCP integration for automated reporting', status: 'todo', priority: 'medium', notes: '' },
      { id: 't9', text: 'Document baseline metrics and methodology in project wiki', status: 'todo', priority: 'medium', notes: '' },
    ]
  },
  {
    id: 'phase-2',
    name: 'Phase 2: Measurement Infrastructure',
    timeline: 'Early February',
    color: '#8b5cf6',
    collapsed: false,
    tasks: [
      { id: 't10', text: 'Set up automated weekly traffic dashboards for /projects pages', status: 'todo', priority: 'high', notes: '' },
      { id: 't11', text: 'Configure alerts for significant traffic changes (spikes/drops)', status: 'todo', priority: 'medium', notes: '' },
      { id: 't12', text: 'Create segmented views: human traffic, bot traffic, LLM traffic', status: 'todo', priority: 'high', notes: '' },
      { id: 't13', text: 'Set up UTM tracking templates for all promotion activities', status: 'todo', priority: 'high', notes: '' },
      { id: 't14', text: 'Verify GA events are firing correctly on all case study pages', status: 'todo', priority: 'medium', notes: '' },
      { id: 't15', text: 'Create Linear project with phases mirroring this tracker', status: 'todo', priority: 'high', notes: '' },
    ]
  },
  {
    id: 'phase-3',
    name: 'Phase 3: Case Study Promotion',
    timeline: 'February – April (ongoing)',
    color: '#ec4899',
    collapsed: false,
    tasks: [
      { id: 't16', text: 'Audit existing case studies on ae.studio/projects for promotion readiness', status: 'todo', priority: 'high', notes: '' },
      { id: 't17', text: 'Identify top 5 highest-potential case studies for initial promotion push', status: 'todo', priority: 'high', notes: '' },
      { id: 't18', text: 'Configure social bots for automated case study sharing schedule', status: 'todo', priority: 'high', notes: '' },
      { id: 't19', text: 'Create social media content calendar for case study promotion', status: 'todo', priority: 'medium', notes: '' },
      { id: 't20', text: 'Set up cross-posting across LinkedIn, Twitter/X, and relevant channels', status: 'todo', priority: 'medium', notes: '' },
      { id: 't21', text: 'Draft promotional copy variants for A/B testing on social', status: 'todo', priority: 'medium', notes: '' },
      { id: 't22', text: 'Implement internal linking strategy between case studies', status: 'todo', priority: 'low', notes: '' },
      { id: 't23', text: 'Explore community/forum sharing opportunities (HN, Reddit, etc.)', status: 'todo', priority: 'low', notes: '' },
    ]
  },
  {
    id: 'phase-4',
    name: 'Phase 4: Ongoing Tracking & Optimization',
    timeline: 'February – April (weekly)',
    color: '#f59e0b',
    collapsed: false,
    tasks: [
      { id: 't24', text: 'Weekly: Pull traffic numbers and compare against baseline', status: 'todo', priority: 'high', notes: '' },
      { id: 't25', text: 'Weekly: Update Linear project with progress and metrics', status: 'todo', priority: 'high', notes: '' },
      { id: 't26', text: 'Bi-weekly: Analyze which promotion channels are driving most human traffic', status: 'todo', priority: 'medium', notes: '' },
      { id: 't27', text: 'Bi-weekly: Adjust promotion strategy based on traffic data', status: 'todo', priority: 'medium', notes: '' },
      { id: 't28', text: 'Monthly: Generate comprehensive traffic growth report', status: 'todo', priority: 'high', notes: '' },
      { id: 't29', text: 'Monthly: Review bot/LLM traffic trends and adjust if needed', status: 'todo', priority: 'low', notes: '' },
      { id: 't30', text: 'End of quarter: Final report — baseline vs. actual, X% growth assessment', status: 'todo', priority: 'high', notes: '' },
    ]
  },
  {
    id: 'phase-5',
    name: 'Phase 5: Success Criteria Validation',
    timeline: 'End of April',
    color: '#10b981',
    collapsed: false,
    tasks: [
      { id: 't31', text: 'Validate baseline traffic is documented and segmented (human/bot/LLM)', status: 'todo', priority: 'high', notes: '' },
      { id: 't32', text: 'Calculate final traffic growth percentage against baseline', status: 'todo', priority: 'high', notes: '' },
      { id: 't33', text: 'Verify all activities are tracked in Linear with defined phases', status: 'todo', priority: 'high', notes: '' },
      { id: 't34', text: 'Document lessons learned and recommendations for next quarter', status: 'todo', priority: 'medium', notes: '' },
      { id: 't35', text: 'Present results to stakeholders with traffic growth narrative', status: 'todo', priority: 'high', notes: '' },
    ]
  }
];

function generateId() {
  return 't' + Date.now() + Math.random().toString(36).substr(2, 5);
}

const statusConfig = {
  todo: { label: 'To Do', bg: '#f1f5f9', text: '#475569', dot: '#94a3b8' },
  'in-progress': { label: 'In Progress', bg: '#dbeafe', text: '#1d4ed8', dot: '#3b82f6' },
  done: { label: 'Done', bg: '#dcfce7', text: '#15803d', dot: '#22c55e' },
  blocked: { label: 'Blocked', bg: '#fee2e2', text: '#b91c1c', dot: '#ef4444' },
};

const priorityConfig = {
  high: { label: 'High', color: '#ef4444' },
  medium: { label: 'Med', color: '#f59e0b' },
  low: { label: 'Low', color: '#6b7280' },
};

export default function App() {
  const [phases, setPhases] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : initialPhases;
    } catch {
      return initialPhases;
    }
  });
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [editingTask, setEditingTask] = useState(null);
  const [editText, setEditText] = useState('');
  const [editNotes, setEditNotes] = useState('');
  const [addingTo, setAddingTo] = useState(null);
  const [newTaskText, setNewTaskText] = useState('');
  const [newTaskPriority, setNewTaskPriority] = useState('medium');
  const [showProjectInfo, setShowProjectInfo] = useState(false);
  const [draggedTask, setDraggedTask] = useState(null);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(phases));
  }, [phases]);

  const allTasks = phases.flatMap(p => p.tasks);
  const totalTasks = allTasks.length;
  const doneTasks = allTasks.filter(t => t.status === 'done').length;
  const inProgressTasks = allTasks.filter(t => t.status === 'in-progress').length;
  const blockedTasks = allTasks.filter(t => t.status === 'blocked').length;
  const progressPct = totalTasks > 0 ? Math.round((doneTasks / totalTasks) * 100) : 0;

  const cycleStatus = useCallback((phaseId, taskId) => {
    const order = ['todo', 'in-progress', 'done', 'blocked'];
    setPhases(prev => prev.map(p => {
      if (p.id !== phaseId) return p;
      return {
        ...p,
        tasks: p.tasks.map(t => {
          if (t.id !== taskId) return t;
          const idx = order.indexOf(t.status);
          return { ...t, status: order[(idx + 1) % order.length] };
        })
      };
    }));
  }, []);

  const deleteTask = useCallback((phaseId, taskId) => {
    setPhases(prev => prev.map(p => {
      if (p.id !== phaseId) return p;
      return { ...p, tasks: p.tasks.filter(t => t.id !== taskId) };
    }));
  }, []);

  const startEdit = useCallback((task) => {
    setEditingTask(task.id);
    setEditText(task.text);
    setEditNotes(task.notes || '');
  }, []);

  const saveEdit = useCallback((phaseId) => {
    if (!editText.trim()) return;
    setPhases(prev => prev.map(p => {
      if (p.id !== phaseId) return p;
      return {
        ...p,
        tasks: p.tasks.map(t => {
          if (t.id !== editingTask) return t;
          return { ...t, text: editText.trim(), notes: editNotes.trim() };
        })
      };
    }));
    setEditingTask(null);
  }, [editingTask, editText, editNotes]);

  const addTask = useCallback((phaseId) => {
    if (!newTaskText.trim()) return;
    setPhases(prev => prev.map(p => {
      if (p.id !== phaseId) return p;
      return {
        ...p,
        tasks: [...p.tasks, {
          id: generateId(),
          text: newTaskText.trim(),
          status: 'todo',
          priority: newTaskPriority,
          notes: ''
        }]
      };
    }));
    setNewTaskText('');
    setAddingTo(null);
  }, [newTaskText, newTaskPriority]);

  const toggleCollapse = useCallback((phaseId) => {
    setPhases(prev => prev.map(p => {
      if (p.id !== phaseId) return p;
      return { ...p, collapsed: !p.collapsed };
    }));
  }, []);

  const setPriority = useCallback((phaseId, taskId, priority) => {
    setPhases(prev => prev.map(p => {
      if (p.id !== phaseId) return p;
      return {
        ...p,
        tasks: p.tasks.map(t => t.id === taskId ? { ...t, priority } : t)
      };
    }));
  }, []);

  const resetAll = useCallback(() => {
    if (window.confirm('Reset all tasks to initial state? This cannot be undone.')) {
      setPhases(initialPhases);
    }
  }, []);

  const handleDragStart = (phaseId, taskId) => {
    setDraggedTask({ phaseId, taskId });
  };

  const handleDrop = (targetPhaseId, targetIndex) => {
    if (!draggedTask) return;
    const { phaseId: srcPhaseId, taskId } = draggedTask;

    setPhases(prev => {
      const newPhases = prev.map(p => ({ ...p, tasks: [...p.tasks] }));
      const srcPhase = newPhases.find(p => p.id === srcPhaseId);
      const taskIndex = srcPhase.tasks.findIndex(t => t.id === taskId);
      const [task] = srcPhase.tasks.splice(taskIndex, 1);
      const targetPhase = newPhases.find(p => p.id === targetPhaseId);
      targetPhase.tasks.splice(targetIndex, 0, task);
      return newPhases;
    });
    setDraggedTask(null);
  };

  const filteredPhases = phases.map(phase => ({
    ...phase,
    tasks: phase.tasks.filter(task => {
      const matchesFilter = filter === 'all' || task.status === filter;
      const matchesSearch = !searchQuery || task.text.toLowerCase().includes(searchQuery.toLowerCase()) || (task.notes && task.notes.toLowerCase().includes(searchQuery.toLowerCase()));
      return matchesFilter && matchesSearch;
    })
  }));

  return (
    <div style={styles.app}>
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.headerLeft}>
            <div style={styles.logo}>
              <span style={styles.logoIcon}>📊</span>
              <div>
                <h1 style={styles.title}>AE Studio Traffic Growth</h1>
                <p style={styles.subtitle}>ae.studio/projects — Baseline & Growth Tracker</p>
              </div>
            </div>
          </div>
          <div style={styles.headerRight}>
            <button style={styles.infoBtn} onClick={() => setShowProjectInfo(!showProjectInfo)}>
              {showProjectInfo ? 'Hide Info' : 'Project Info'}
            </button>
            <button style={styles.resetBtn} onClick={resetAll}>Reset</button>
          </div>
        </div>

        {showProjectInfo && (
          <div style={styles.projectInfo}>
            <div style={styles.infoGrid}>
              <div style={styles.infoCard}>
                <h3 style={styles.infoCardTitle}>Goal</h3>
                <p style={styles.infoCardText}>Establish baseline traffic measurement for ae.studio/projects, segment by type (humans, bots, LLMs), and grow meaningful traffic through systematic case study promotion.</p>
              </div>
              <div style={styles.infoCard}>
                <h3 style={styles.infoCardTitle}>Why It Matters</h3>
                <p style={styles.infoCardText}>Case studies are a core sales asset. Driving the right traffic to project pages supports every BD initiative regardless of channel or strategy.</p>
              </div>
              <div style={styles.infoCard}>
                <h3 style={styles.infoCardTitle}>Tools</h3>
                <p style={styles.infoCardText}>Google Analytics, Google Search Console, Cloudflare Analytics, GA MCP, Linear, Social Bots</p>
              </div>
              <div style={styles.infoCard}>
                <h3 style={styles.infoCardTitle}>Timeline</h3>
                <p style={styles.infoCardText}>Feb baseline → Feb–Apr ongoing promotion → End of April final assessment</p>
              </div>
            </div>
            <div style={styles.deliverables}>
              <h3 style={styles.delTitle}>Deliverables</h3>
              <ul style={styles.delList}>
                <li>Baseline traffic report: total visits, unique visitors, traffic sources, human vs. bot vs. LLM breakdown</li>
                <li>Linear project with phases tracking all activities and progress</li>
                <li>[X%] traffic growth from baseline by end of quarter (target TBD after baseline)</li>
              </ul>
            </div>
          </div>
        )}

        <div style={styles.stats}>
          <div style={styles.progressContainer}>
            <div style={styles.progressBar}>
              <div style={{ ...styles.progressFill, width: `${progressPct}%` }} />
            </div>
            <span style={styles.progressText}>{progressPct}% complete</span>
          </div>
          <div style={styles.statCards}>
            <div style={styles.statCard}>
              <span style={styles.statNum}>{totalTasks}</span>
              <span style={styles.statLabel}>Total</span>
            </div>
            <div style={{ ...styles.statCard, borderLeft: '3px solid #3b82f6' }}>
              <span style={{ ...styles.statNum, color: '#3b82f6' }}>{inProgressTasks}</span>
              <span style={styles.statLabel}>In Progress</span>
            </div>
            <div style={{ ...styles.statCard, borderLeft: '3px solid #22c55e' }}>
              <span style={{ ...styles.statNum, color: '#22c55e' }}>{doneTasks}</span>
              <span style={styles.statLabel}>Done</span>
            </div>
            <div style={{ ...styles.statCard, borderLeft: '3px solid #ef4444' }}>
              <span style={{ ...styles.statNum, color: '#ef4444' }}>{blockedTasks}</span>
              <span style={styles.statLabel}>Blocked</span>
            </div>
          </div>
        </div>

        <div style={styles.controls}>
          <div style={styles.searchWrap}>
            <span style={styles.searchIcon}>🔍</span>
            <input
              style={styles.searchInput}
              placeholder="Search tasks..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button style={styles.clearSearch} onClick={() => setSearchQuery('')}>✕</button>
            )}
          </div>
          <div style={styles.filters}>
            {['all', 'todo', 'in-progress', 'done', 'blocked'].map(f => (
              <button
                key={f}
                style={{
                  ...styles.filterBtn,
                  ...(filter === f ? styles.filterBtnActive : {}),
                  ...(f !== 'all' ? { borderLeft: `3px solid ${statusConfig[f]?.dot || '#6366f1'}` } : {})
                }}
                onClick={() => setFilter(f)}
              >
                {f === 'all' ? 'All' : statusConfig[f].label}
              </button>
            ))}
          </div>
        </div>
      </header>

      <main style={styles.main}>
        {filteredPhases.map(phase => {
          const phaseDone = phase.tasks.filter(t => t.status === 'done').length;
          const phaseTotal = phase.tasks.length;
          const phasePct = phaseTotal > 0 ? Math.round((phaseDone / phaseTotal) * 100) : 0;

          return (
            <section key={phase.id} style={styles.phase}>
              <div
                style={{ ...styles.phaseHeader, borderLeft: `4px solid ${phase.color}` }}
                onClick={() => toggleCollapse(phase.id)}
              >
                <div style={styles.phaseHeaderLeft}>
                  <span style={styles.collapseIcon}>{phase.collapsed ? '▶' : '▼'}</span>
                  <div>
                    <h2 style={styles.phaseName}>{phase.name}</h2>
                    <span style={styles.phaseTimeline}>{phase.timeline}</span>
                  </div>
                </div>
                <div style={styles.phaseHeaderRight}>
                  <span style={styles.phaseCount}>{phaseDone}/{phaseTotal}</span>
                  <div style={styles.miniProgress}>
                    <div style={{ ...styles.miniProgressFill, width: `${phasePct}%`, background: phase.color }} />
                  </div>
                </div>
              </div>

              {!phase.collapsed && (
                <div style={styles.taskList}>
                  {phase.tasks.map((task, index) => (
                    <div
                      key={task.id}
                      style={{
                        ...styles.taskItem,
                        ...(task.status === 'done' ? styles.taskDone : {}),
                        opacity: draggedTask?.taskId === task.id ? 0.4 : 1
                      }}
                      draggable
                      onDragStart={() => handleDragStart(phase.id, task.id)}
                      onDragOver={e => e.preventDefault()}
                      onDrop={() => handleDrop(phase.id, index)}
                    >
                      {editingTask === task.id ? (
                        <div style={styles.editForm}>
                          <input
                            style={styles.editInput}
                            value={editText}
                            onChange={e => setEditText(e.target.value)}
                            onKeyDown={e => e.key === 'Enter' && saveEdit(phase.id)}
                            autoFocus
                          />
                          <textarea
                            style={styles.editNotes}
                            placeholder="Add notes..."
                            value={editNotes}
                            onChange={e => setEditNotes(e.target.value)}
                            rows={2}
                          />
                          <div style={styles.editActions}>
                            <button style={styles.saveBtn} onClick={() => saveEdit(phase.id)}>Save</button>
                            <button style={styles.cancelBtn} onClick={() => setEditingTask(null)}>Cancel</button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div style={styles.taskLeft}>
                            <button
                              style={{
                                ...styles.statusDot,
                                background: statusConfig[task.status].bg,
                                color: statusConfig[task.status].text,
                                borderColor: statusConfig[task.status].dot,
                              }}
                              onClick={() => cycleStatus(phase.id, task.id)}
                              title="Click to change status"
                            >
                              {task.status === 'done' ? '✓' : task.status === 'blocked' ? '!' : task.status === 'in-progress' ? '→' : '○'}
                            </button>
                            <div style={styles.taskContent}>
                              <span style={{
                                ...styles.taskText,
                                textDecoration: task.status === 'done' ? 'line-through' : 'none',
                                color: task.status === 'done' ? '#94a3b8' : '#1e293b'
                              }}>
                                {task.text}
                              </span>
                              {task.notes && <p style={styles.taskNotes}>{task.notes}</p>}
                            </div>
                          </div>
                          <div style={styles.taskRight}>
                            <select
                              style={{
                                ...styles.prioritySelect,
                                color: priorityConfig[task.priority].color,
                                borderColor: priorityConfig[task.priority].color + '44',
                              }}
                              value={task.priority}
                              onChange={e => setPriority(phase.id, task.id, e.target.value)}
                            >
                              <option value="high">High</option>
                              <option value="medium">Med</option>
                              <option value="low">Low</option>
                            </select>
                            <button style={styles.editBtn} onClick={() => startEdit(task)} title="Edit">✎</button>
                            <button style={styles.deleteBtn} onClick={() => deleteTask(phase.id, task.id)} title="Delete">✕</button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}

                  {phase.tasks.length === 0 && (
                    <div style={styles.emptyState}>No tasks match your filter</div>
                  )}

                  {addingTo === phase.id ? (
                    <div style={styles.addForm}>
                      <input
                        style={styles.addInput}
                        placeholder="New task description..."
                        value={newTaskText}
                        onChange={e => setNewTaskText(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && addTask(phase.id)}
                        autoFocus
                      />
                      <select
                        style={styles.addPriority}
                        value={newTaskPriority}
                        onChange={e => setNewTaskPriority(e.target.value)}
                      >
                        <option value="high">High</option>
                        <option value="medium">Medium</option>
                        <option value="low">Low</option>
                      </select>
                      <button style={styles.addConfirm} onClick={() => addTask(phase.id)}>Add</button>
                      <button style={styles.addCancel} onClick={() => { setAddingTo(null); setNewTaskText(''); }}>Cancel</button>
                    </div>
                  ) : (
                    <button style={styles.addTaskBtn} onClick={() => setAddingTo(phase.id)}>
                      + Add Task
                    </button>
                  )}
                </div>
              )}
            </section>
          );
        })}
      </main>

      <footer style={styles.footer}>
        <p>AE Studio — Traffic Growth Project Tracker | Data persists in your browser</p>
      </footer>
    </div>
  );
}

const styles = {
  app: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    minHeight: '100vh',
    background: '#f8fafc',
    color: '#1e293b',
    margin: 0,
  },
  header: {
    background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 50%, #4338ca 100%)',
    color: 'white',
    padding: '0 0 24px 0',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 32px 16px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  headerLeft: {},
  headerRight: { display: 'flex', gap: '8px' },
  logo: { display: 'flex', alignItems: 'center', gap: '12px' },
  logoIcon: { fontSize: '36px' },
  title: { margin: 0, fontSize: '22px', fontWeight: 700, letterSpacing: '-0.02em' },
  subtitle: { margin: '2px 0 0', fontSize: '13px', opacity: 0.75, fontWeight: 400 },
  infoBtn: {
    background: 'rgba(255,255,255,0.15)',
    border: '1px solid rgba(255,255,255,0.25)',
    color: 'white',
    padding: '6px 14px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    transition: 'background 0.2s',
  },
  resetBtn: {
    background: 'rgba(239,68,68,0.2)',
    border: '1px solid rgba(239,68,68,0.4)',
    color: '#fca5a5',
    padding: '6px 14px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
  },
  projectInfo: {
    padding: '0 32px 16px',
    animation: 'fadeIn 0.2s ease',
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '12px',
    marginBottom: '12px',
  },
  infoCard: {
    background: 'rgba(255,255,255,0.1)',
    borderRadius: '8px',
    padding: '14px',
    backdropFilter: 'blur(10px)',
  },
  infoCardTitle: { margin: '0 0 6px', fontSize: '13px', fontWeight: 600, opacity: 0.9 },
  infoCardText: { margin: 0, fontSize: '12px', lineHeight: 1.5, opacity: 0.8 },
  deliverables: {
    background: 'rgba(255,255,255,0.08)',
    borderRadius: '8px',
    padding: '14px',
  },
  delTitle: { margin: '0 0 8px', fontSize: '13px', fontWeight: 600 },
  delList: { margin: 0, paddingLeft: '18px', fontSize: '12px', lineHeight: 1.7, opacity: 0.85 },
  stats: { padding: '0 32px 12px' },
  progressContainer: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' },
  progressBar: {
    flex: 1,
    height: '8px',
    background: 'rgba(255,255,255,0.15)',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    background: 'linear-gradient(90deg, #22c55e, #4ade80)',
    borderRadius: '4px',
    transition: 'width 0.4s ease',
  },
  progressText: { fontSize: '13px', fontWeight: 600, opacity: 0.9, minWidth: '90px', textAlign: 'right' },
  statCards: { display: 'flex', gap: '10px', flexWrap: 'wrap' },
  statCard: {
    background: 'rgba(255,255,255,0.1)',
    borderRadius: '8px',
    padding: '10px 16px',
    minWidth: '80px',
    textAlign: 'center',
    borderLeft: '3px solid rgba(255,255,255,0.3)',
  },
  statNum: { display: 'block', fontSize: '22px', fontWeight: 700 },
  statLabel: { display: 'block', fontSize: '11px', opacity: 0.7, marginTop: '2px' },
  controls: {
    padding: '0 32px',
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  searchWrap: {
    position: 'relative',
    flex: '1 1 200px',
    minWidth: '200px',
  },
  searchIcon: {
    position: 'absolute',
    left: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '14px',
    pointerEvents: 'none',
  },
  searchInput: {
    width: '100%',
    padding: '8px 30px 8px 32px',
    borderRadius: '6px',
    border: '1px solid rgba(255,255,255,0.2)',
    background: 'rgba(255,255,255,0.1)',
    color: 'white',
    fontSize: '13px',
    outline: 'none',
    boxSizing: 'border-box',
  },
  clearSearch: {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    color: 'rgba(255,255,255,0.6)',
    cursor: 'pointer',
    fontSize: '14px',
  },
  filters: { display: 'flex', gap: '6px', flexWrap: 'wrap' },
  filterBtn: {
    padding: '6px 12px',
    borderRadius: '6px',
    border: '1px solid rgba(255,255,255,0.2)',
    background: 'rgba(255,255,255,0.05)',
    color: 'rgba(255,255,255,0.75)',
    cursor: 'pointer',
    fontSize: '12px',
    transition: 'all 0.2s',
    fontWeight: 500,
  },
  filterBtnActive: {
    background: 'rgba(255,255,255,0.2)',
    color: 'white',
    borderColor: 'rgba(255,255,255,0.4)',
  },
  main: { padding: '24px 32px', maxWidth: '1100px', margin: '0 auto' },
  phase: {
    marginBottom: '20px',
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
  phaseHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background 0.2s',
    background: '#fafbfc',
  },
  phaseHeaderLeft: { display: 'flex', alignItems: 'center', gap: '10px' },
  collapseIcon: { fontSize: '12px', color: '#64748b', width: '16px' },
  phaseName: { margin: 0, fontSize: '15px', fontWeight: 600, color: '#1e293b' },
  phaseTimeline: { fontSize: '12px', color: '#64748b', marginTop: '2px', display: 'block' },
  phaseHeaderRight: { display: 'flex', alignItems: 'center', gap: '10px' },
  phaseCount: { fontSize: '13px', color: '#64748b', fontWeight: 500 },
  miniProgress: {
    width: '60px',
    height: '4px',
    background: '#e2e8f0',
    borderRadius: '2px',
    overflow: 'hidden',
  },
  miniProgressFill: {
    height: '100%',
    borderRadius: '2px',
    transition: 'width 0.4s ease',
  },
  taskList: { padding: '4px 20px 16px' },
  taskItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 12px',
    margin: '4px 0',
    borderRadius: '8px',
    border: '1px solid #f1f5f9',
    transition: 'all 0.2s',
    cursor: 'grab',
    background: 'white',
  },
  taskDone: {
    background: '#f8fdf9',
    borderColor: '#dcfce7',
  },
  taskLeft: { display: 'flex', alignItems: 'flex-start', gap: '10px', flex: 1 },
  statusDot: {
    width: '28px',
    height: '28px',
    borderRadius: '6px',
    border: '2px solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 700,
    flexShrink: 0,
    transition: 'all 0.2s',
  },
  taskContent: { flex: 1, minWidth: 0 },
  taskText: { fontSize: '13px', lineHeight: 1.4, display: 'block' },
  taskNotes: { margin: '4px 0 0', fontSize: '11px', color: '#94a3b8', lineHeight: 1.4 },
  taskRight: { display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0, marginLeft: '8px' },
  prioritySelect: {
    padding: '2px 4px',
    borderRadius: '4px',
    border: '1px solid',
    fontSize: '11px',
    fontWeight: 600,
    cursor: 'pointer',
    background: 'white',
    outline: 'none',
  },
  editBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#94a3b8',
    padding: '4px',
    borderRadius: '4px',
    transition: 'color 0.2s',
  },
  deleteBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#cbd5e1',
    padding: '4px',
    borderRadius: '4px',
    transition: 'color 0.2s',
  },
  editForm: { width: '100%', display: 'flex', flexDirection: 'column', gap: '8px' },
  editInput: {
    padding: '8px 10px',
    borderRadius: '6px',
    border: '1px solid #e2e8f0',
    fontSize: '13px',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  editNotes: {
    padding: '8px 10px',
    borderRadius: '6px',
    border: '1px solid #e2e8f0',
    fontSize: '12px',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'inherit',
    width: '100%',
    boxSizing: 'border-box',
  },
  editActions: { display: 'flex', gap: '6px' },
  saveBtn: {
    padding: '5px 14px',
    borderRadius: '5px',
    border: 'none',
    background: '#6366f1',
    color: 'white',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 500,
  },
  cancelBtn: {
    padding: '5px 14px',
    borderRadius: '5px',
    border: '1px solid #e2e8f0',
    background: 'white',
    cursor: 'pointer',
    fontSize: '12px',
  },
  addForm: {
    display: 'flex',
    gap: '8px',
    padding: '8px 0',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  addInput: {
    flex: 1,
    padding: '8px 10px',
    borderRadius: '6px',
    border: '1px solid #e2e8f0',
    fontSize: '13px',
    outline: 'none',
    minWidth: '200px',
  },
  addPriority: {
    padding: '6px 8px',
    borderRadius: '6px',
    border: '1px solid #e2e8f0',
    fontSize: '12px',
    outline: 'none',
  },
  addConfirm: {
    padding: '6px 16px',
    borderRadius: '6px',
    border: 'none',
    background: '#6366f1',
    color: 'white',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 500,
  },
  addCancel: {
    padding: '6px 14px',
    borderRadius: '6px',
    border: '1px solid #e2e8f0',
    background: 'white',
    cursor: 'pointer',
    fontSize: '12px',
  },
  addTaskBtn: {
    background: 'none',
    border: '1px dashed #e2e8f0',
    borderRadius: '6px',
    padding: '8px',
    width: '100%',
    cursor: 'pointer',
    color: '#94a3b8',
    fontSize: '13px',
    transition: 'all 0.2s',
    marginTop: '4px',
  },
  emptyState: {
    textAlign: 'center',
    padding: '20px',
    color: '#94a3b8',
    fontSize: '13px',
  },
  footer: {
    textAlign: 'center',
    padding: '24px',
    color: '#94a3b8',
    fontSize: '12px',
    borderTop: '1px solid #f1f5f9',
  },
};
